import * as React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from 'themes/defaultTheme';
import CustomGlobalStyles from 'themes/CustomGlobalStyles';

export default function withRoot<P>(Component: React.ComponentType<P>) {

  function WithRoot(props: P) {
    return (
      <ThemeProvider theme={theme}>
        {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
        <CssBaseline />
        {/* Override global styles */}
        <CustomGlobalStyles />
        <Component {...props} />
      </ThemeProvider>
    );
  }

  return WithRoot;
}